import { render, staticRenderFns } from "./available_to_invest.vue?vue&type=template&id=25936a66&"
import script from "./available_to_invest.vue?vue&type=script&lang=js&"
export * from "./available_to_invest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports